<template>
  <div>
    <nx-navigation-selector
      :value="value"
      :label="label"
      :name="newNavigationName"
      :deletable="deletable"
      :data-vv-name="name"
      :data-vv-scope="scope"
      :data-vv-as="label"
      @input="onInput"
      data-vv-value-path="value"
      v-bind="$attrs"
      v-validate="validation"
    ></nx-navigation-selector>
  </div>
</template>
<script>
import FormElement from '@/modules/form/mixins/form-element';
import Selector from '@/modules/navigation/Selector';

export default {
  name: 'nx-form-navigation-selector',
  mixins: [FormElement],
  components: {
    [Selector.name]: Selector,
  },
  props: {
    value: {
      required: true,
      validator: prop => typeof prop === 'object' || prop === null || prop === undefined,
    },
    label: {
      type: String,
      required: true,
    },
    deletable: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  methods: {
    onInput(value) {
      this.$parentForm.updateField(this.name, value);
      this.$emit('input', value);
    },
  },
  computed: {
    newNavigationName() {
      const entityName = this.$parentForm.draft.name || this.$parentForm.draft.title || null;
      if (entityName) {
        return `${this.label} - ${entityName}`;
      }
      return this.label;
    },
  },
};
</script>

<style>
</style>
